import { render, staticRenderFns } from "./RoofCalLayout.vue?vue&type=template&id=5d8f0a84&scoped=true"
import script from "./RoofCalLayout.vue?vue&type=script&lang=js"
export * from "./RoofCalLayout.vue?vue&type=script&lang=js"
import style0 from "./RoofCalLayout.vue?vue&type=style&index=0&id=5d8f0a84&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8f0a84",
  null
  
)

export default component.exports